/*
 *		Copyright (c) 2015 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .directive('accOpenModalOnLoad', ['$location', '$routeParams', 'SyncAndShareNode', 'editNotificationShare', 'removeAllNotifications', function($location, $routeParams, SyncAndShareNode, editNotificationShare, removeAllNotifications) {
        return {
            link: function() {
                var dialog = $location.search()['dialog'];

                if (dialog) {
                    $location.search('dialog', null);

                    var openDialog = function (node) {
                        node = node || ''; // not all dialogs will require a node as param

                        if (dialog == 'manage_notifications') {
                            editNotificationShare.showDialog(node);
                        } else if (dialog == 'remove_notifications') {
                            removeAllNotifications(node);
                        }
                    };

                    SyncAndShareNode.get({uuid: $routeParams.uuid}, function (currentNode) {
                        openDialog(currentNode);
                    });
                }
            }
        }
    }]);